<script lang="ts">
	import { t } from "@hitit/hub/src/stores";
	import NO_RROUTE_IMAGE from "../assets/img/404.png";
	import AppLayout from "../layouts/AppLayout.svelte";

</script>

<AppLayout useTerm={false}>
	<img src={NO_RROUTE_IMAGE} alt="404" on:click={() => location.assign('/')} />
	<div class="container">
		<span>404</span>
		<p>{$t('sso.error.404')}</p>
	</div>
</AppLayout>

<style lang="scss">
	.container {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		gap: 10px;
		background-color: #333338;

		box-sizing: border-box;
		padding: 30px;
		width: 100%;
		max-width: 460px;

		color: white;
		font-size: 1.25rem;
		border-radius: 10px;
		font-weight: 500;
	}
	img {
		width: 148.1px;
		height: 66.7px;
		margin-bottom: 60px;

		&:hover {
			cursor: pointer;
		}
	}

</style>
